<template>
  <div class="cod_orders_list">
    <table class="table table-striped table-sm table-hover">
      <thead>
      <tr>
        <th width="20"></th>
        <th width="70">Номер</th>
        <th width="15%">Клиент</th>
        <th width="25%">Адрес</th>
        <th width="20%">Препараты</th>
        <th>Сумма</th>
        <th>Расходы</th>
        <th width="15%">Трек номер</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(o, i) in orders" :key="o.id" @click="selectOrder(o.id)">
        <td>
          <p>{{ i + 1 }}</p>
          <input type="checkbox" v-model="selectedOrders[o.id]">
        </td>
        <td>
          <p>{{ mixinPrintOrderNum(o.id) }}</p>
          <p>{{ o.created_at }}</p>
        </td>
        <td>
          <p>{{ o.client && o.client.name || o.extra_options.client_name }}</p>
          <template v-if="o.phones && o.phones.length">
            <p v-for="phone in o.phones" :key="phone.id">
              <strong>{{ mixinPrintPhone(phone.full_phone) }}</strong>
            </p>
          </template>
          <template v-else>
            <p>{{ o.phone }}</p>
          </template>
          <p>{{ o.client && o.client.email || o.extra_options.email }}</p>
        </td>
        <td>
          <div class="input-group">
            <textarea :disabled="disableEdit" v-model="o.address" class='form-control' rows="2"></textarea>
            <!--            <input type="text" v-model="o.address" class="form-control" placeholder="Адрес">-->
            <div v-if="!disableEdit" class="input-group-append">
              <button @click="updateOrder(o.id)" class="btn btn-outline-success btn-xs">
                <i class="icon-fa icon-fa-save"></i>
              </button>
            </div>
          </div>
        </td>
        <td>
          <div class="drugs_list_block" v-html="printDrugs(o.details)"/>
        </td>
        <td>{{ o.price.toLocaleString('ru-RU') }}
        </td>
        <td>
          <div class="input-group">
            <input type="text" :disabled="disableEdit" v-model="o.extra_options.post_sum" class="form-control" placeholder="Почтовые расходы">
            <div v-if="!disableEdit" class="input-group-append">
              <button @click="updateOrder(o.id)" class="btn btn-outline-success btn-xs">
                <i class="icon-fa icon-fa-save"></i>
              </button>
            </div>
          </div>
        </td>
        <td v-if="appointed">
          <div class="input-group">
            <input type="text" :disabled="disableEdit" v-model="o.extra_options.post_track" class="form-control" placeholder="Номер с почты">
            <div v-if="!disableEdit" class="input-group-append">
              <button @click="updateOrder(o.id)" class="btn btn-outline-success btn-xs">
                <i class="icon-fa icon-fa-save"></i>
              </button>
            </div>
            <div v-else class="input-group-append">
              <button @click="uploadFileData(o)" class="btn btn-info btn-xs">
                <v-popover
                  class=""
                  popoverClass="1111"
                  popoverInnerClass="upload_file_component_popover"
                  :auto-hide="true">
                  <i class="icon-fa icon-fa-eye"></i>
                  <template slot="popover">
                    <div class="pre_image">
                      <img v-if="uploadedImage[o.id]" :src="uploadedImage[o.id].url">
                    </div>
                  </template>
                </v-popover>
              </button>
            </div>
          </div>
          <div class="text-right" v-if="!disableEdit">
            <UploadFile
              :orderId="o.id"
              type="postTrack"
              :uploadedKey="o.extra_options.post_track_image || null"
            />
          </div>
        </td>
        <td>
          <div v-if="disableEdit">
            <!--            <button class="btn btn-outline-warning btn-xs">Отменить</button>-->
            <button
              v-if="!popover[o.id] || !popover[o.id].reject"
              type="button"
              @click="popover[o.id].reject = true"
              class="btn btn-outline-warning btn-xs"
            >
              Отменить
            </button>
            <v-popover
              popoverInnerClass="reject_popover"
              v-if="popover[o.id] && popover[o.id].reject"
              @hide="destroyPopover(o.id)"
              :open="popover[o.id].reject"
            >
              <button type="button" class="btn btn-outline-warning btn-xs">
                Отменить
              </button>
              <template slot="popover">
                <div>
                  <label for="">Почтовые расходы</label>
                  <input type="number" class="form-control" v-model="o.extra_options.rejectPostExpenses">
                  <div class="text-right mt-1">
                    <button @click="updateOrder(o.id, 'rejectCodDelivery')" type="button" class="btn btn-warning btn-xs">Подтвердить</button>
                  </div>
                </div>
              </template>
            </v-popover>

          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import api from "@/api";
import UploadFile from "@/components/files/UploadFile";

export default {
  components: {UploadFile},
  props: ['orders', 'appointed', 'disableEdit'],
  data() {
    return {
      popover: {},
      localOrders: [],
      selectedOrders: {},
      uploadedImage: {},
      rejectPostExpenses: 0
    }
  },
  mounted() {
    this.selectedOrders = this.orders.reduce((acc, o) => {
      acc[o.id] = false;
      this.popover[o.id] = {
        reject: false
      };
      return acc;
    }, {});
    this.localOrders = [...this.orders];
    this.popover = {...this.popover};
  },
  methods: {
    destroyPopover(orderId) {
      this.popover[orderId] = {
        reject: false,
      };
      this.rejectPostExpenses = 0;
    },
    async uploadFileData(order) {
      if (!this.uploadedImage[order.id] && order.extra_options.post_track_image) {
        const {data} = await api.index('/uploads/getImgLinkByKey?key=' + order.extra_options.post_track_image);
        if (data.success) {
          this.uploadedImage[order.id] = {
            url: data.link
          }
          this.uploadedImage = {...this.uploadedImage};
        }
      }
    },
    async updateOrder(orderId, action = 'update') {
      const order = this.localOrders.find((o) => o.id === orderId);
      const {data} = await api.post('/orders/updateOrder', {
        order: {
          action,
          id: order.id,
          extra_options: order.extra_options,
          address: order.address,
        },
      });
      if (data.success) {
        toastr["success"]("Обновлено");
      } else {
        toastr["warning"](data.message || "Ошибка сервера");
      }
    },
    selectOrder(id) {
      // selectedOrders[o.id] = !selectedOrders[o.id]
    },
    printDrugs(drugs) {
      let text = '';
      drugs.forEach((d) => {
        text += '<div><p>' + d.drug.prep + '</p>';
        text += '<p><strong>' + (d.drug.komplekt != 1 ? ((d.qty / d.drug.komplekt) + '(к) x ' + (d.price * d.drug.komplekt)) : (d.qty + ' x ' + d.price)) + '</strong>';
        if (this.rates && this.rates[38] && this.rates[38] != 1) {
          text += ' <strong>(' + Math.round(d.price * this.rates[38] * 10) / 10 + ')</strong>';
        }
        text += '</p></div>';
      })
      return text;
    },
  }
}
</script>

<style scoped>
table.table p {
  margin-bottom: 1px;
}

.pre_image img {
  max-width: 200px;
  max-height: 200px;
}
</style>
<style>
.cod_orders_list .drugs_list_block p {
  margin-bottom: 1px;
}

.upload_file_component_popover {
  max-width: 250px;
}

.reject_popover {
  padding: 10px;

}
</style>
